import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Box, Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const Wrapper = styled(Center)``;

export const CustomBox = styled(Box)`
    position: relative;
`;

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 20, 700)}
`;

export const CustomLocalNavBar = styled(Center)`
    position: absolute;
    opacity: 0;
    visibility: hidden;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 176px;
    transition: 1s cubic-bezier(0.215, 0.61, 0.355, 1);

    &.on {
        opacity: 1;
        top: 65px;
        visibility: visible;
    }

    &.off {
        opacity: 0;
        top: 120px;
        visibility: hidden;
    }
`;

export const CustomText = styled(Text)`
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.bgColor[200]};
    ${FONT("pretendard", 14, 300)}
`;

export const CustomButton = styled(Button)`
    ${FONT("pretendard", 16, 300)}
`;
